import { Injectable } from '@angular/core';
import { CalloutComponentInterface } from './callout.types';

@Injectable({ providedIn: 'root' })
export class CalloutService {
  private activeHoverCallout: CalloutComponentInterface;

  activateHover(callout: CalloutComponentInterface) {
    if (this.activeHoverCallout) {
      this.activeHoverCallout.close();
    }

    this.activeHoverCallout = callout;
  }
}
